<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- logo -->
        <b-link class="brand-logo">
          <h2 class="brand-text text-primary ml-1">
            اتوماسیون 5040
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          🔒تغییر رمز عبور
        </b-card-title>
        <b-card-text class="mb-2">
          برای ادامه استفاده از برنامه ملزم به تغییر رمز عبور خود می باشید.
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
              method="POST"
              class="auth-reset-password-form mt-2"
              @submit.prevent="validationForm"
          >

            <!-- password -->
            <b-form-group
                label="رمز جدید"
                label-for="reset-password-new"
            >
              <validation-provider
                  #default="{ errors }"
                  name="رمز عبور"
                  vid="Password"
                  rules="required"
              >
                <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group
                label-for="reset-password-confirm"
                label="تکرار رمز عبور"
            >
              <validation-provider
                  #default="{ errors }"
                  name="تکرار رمز عبور"
                  rules="required|confirmed:Password"
              >
                <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
                block
                type="submit"
                variant="primary"
            >
              تغییر رمز عبور
            </b-button>
          </b-form>
        </validation-observer>

      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BCard, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import farsi from 'vee-validate/dist/locale/fa'
import store from '@/store'

export default {
  components: {
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.$http.post('force-reset-password', {
                'password': this.password,
                'password_confirmation': this.cPassword
              })
                  .then(({ data }) => {
                    if (data.status) {
                      store.commit('user/UPDATE_USER_DATA', data.user);

                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'تغییر رمز عبور با موفقیت انجام شد',
                          icon: 'EditIcon',
                          variant: 'success',
                        },
                      })
                      this.$router.push('/').catch(() => {})
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: data.message,
                          icon: 'EditIcon',
                          variant: 'danger',
                        },
                      })
                    }
                  })
                  .catch(data => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: data.response.data.message ?? data.message,
                        icon: 'EditIcon',
                        variant: 'danger',
                      },
                    })
                  })

            }
          })
    },
  },
  created() {
    localize('fa', {
      messages: farsi.messages
    })
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
